import React from 'react';
import alertIcon from '../../Constant/Icons/alert.svg';

const AdminUnauthorized = () => {
  return (
    <>
      <style>
        {`
          .container {
            min-height: 100vh;
            background-color: #f3f4f6;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 1rem;
          }
          .card {
            background-color: #ffffff;
            border-radius: 0.5rem;
            box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
            padding: 1.5rem;
            max-width: 24rem;
            text-align: center;
          }
          .title {
            font-size: 1.5rem;
            font-weight: 700;
            color: #2563eb;
            margin-bottom: 0.75rem;
            text-align: center;
          }
          .icon {
            width: 3rem;
            height: 3rem;
            margin: 1rem auto;
            color: #dc2626;
          }
        `}
      </style>
      <div className="container">
        <div className="card">
          <h1 className="title">
            This section’s still loading for juniors… Might take a semester or two!
          </h1>
          <div className="icon">
            <img className="IconForInput" src={alertIcon} alt="Alert" width={50} height={50} />
          </div>
          {/* <button 
            className="button"
            onClick={() => alert('Whoa, junior! This server’s in the danger zone—proceed with caution or bribe it with some virtual coffee!')}
          >
            Nudge Server
          </button> */}
        </div>
      </div>
    </>
  );
};

export default AdminUnauthorized;